import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Notification } from "src/app/models/notification.model";
import { BaseApiService } from "./base-api.service";

@Injectable({
  providedIn: "root",
})
export class NotificationService extends BaseApiService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  getNotifications(): Observable<Notification[]> {
    return this.get("/employee/me/notifications", true);
  }

  updateNotification(
    notificationId: string,
    updateNotificationModel: Record<string, any>
  ): Observable<Notification> {
    return this.put(`/employee/me/${notificationId}`, updateNotificationModel);
  }

  checkTime(dateString: string): boolean {
    const date = new Date(dateString);
    const ninetyDaysAgo = new Date(Date.now() - 90 * 24 * 60 * 60 * 1000);
    return date >= ninetyDaysAgo;
  }
}
